import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserDto } from '@api/core';
import { checkShellAccess, currentUser$ } from '@stillmandigital/common';
import { SharedComplianceStore } from 'app/compliance/shared-compliance.store';
import { map } from 'rxjs';

export const complianceShellGuard: CanActivateFn = () => {
  const router = inject(Router);

  return currentUser$<UserDto>(inject(SharedComplianceStore)).pipe(map(user => resolve(user, router)));
};

function resolve(user: UserDto | undefined, router: Router): boolean | ReturnType<Router['createUrlTree']> {
  const access = checkShellAccess(user, router);
  if (access !== true) {
    return access;
  }
  if (user?.role !== UserDto.RoleEnum.AdminCompliance) {
    return router.createUrlTree(['/']);
  }
  return true;
}
